import React, { useRef } from "react";
import { Modal } from "antd";
import YouTube from "react-youtube";

export default function TutorialModal({ open, onClose }) {
  const playerRef = useRef(null);

  const handleReady = (event) => {
    playerRef.current = event.target;
    event.target.playVideo(); // autoplay quando abrir
  };

  const handleStateChange = (event) => {
    // 0 = vídeo terminou
    if (event.data === 0) {
      onClose(); // fecha modal automaticamente
    }
  };

  const handleClose = () => {
    if (playerRef.current) {
      playerRef.current.stopVideo();
    }
    onClose();
  };

  return (
    <Modal
      title="Tutorial do Cliente"
      open={open}
      onCancel={handleClose}
      footer={null}
      width={800}
      destroyOnClose
      style={{ top: 20 }}
      className="premium-modal-v2"
      closable={true}
    >
      <div className="flex justify-center">
        <YouTube
          videoId="2BEl2PgQ3nM" // seu vídeo
          opts={{
            width: "100%",
            playerVars: { autoplay: 1 },
          }}
          onReady={handleReady}
          onStateChange={handleStateChange}
        />
      </div>
    </Modal>
  );
}
